import { render, staticRenderFns } from "./FormTableItems.vue?vue&type=template&id=cf9d43cc&scoped=true"
import script from "./FormTableItems.vue?vue&type=script&lang=js"
export * from "./FormTableItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9d43cc",
  null
  
)

export default component.exports